import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Loader2, ShoppingBag, Wand2, LayoutGrid } from "lucide-react";
import http from "@/api";
import { useApp } from "@/context";
import { getVid } from "@/lib/vid";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
const src = (u) => (u && u.startsWith("/") ? `${API_BASE}${u}` : u);

export default function Design() {
  const { id } = useParams();
  const nav = useNavigate();
  const { lang } = useApp();
  const ar = lang !== "en";
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    localStorage.setItem("rg_design_ref", id);
    http.get(`/ai/design/${id}?vid=${encodeURIComponent(getVid())}`)
      .then(({ data: d }) => setData(d)).catch(() => setErr(true));
  }, [id]);

  if (err) {
    return (
      <div className="p-10 text-center space-y-3" data-testid="design-not-found">
        <div className="text-sm opacity-60">{ar ? "التصميم غير موجود أو انتهت صلاحيته" : "Design not found"}</div>
        <button onClick={() => nav("/")} className="btn-primary !py-2.5 !px-6 text-sm">{ar ? "تسوّق من RG" : "Shop RG"}</button>
      </div>
    );
  }
  if (!data) return <div className="p-12 flex justify-center"><Loader2 className="animate-spin text-emerald-700" size={28} /></div>;

  const { design, product } = data;
  return (
    <div className="max-w-lg mx-auto px-4 py-6 space-y-4" data-testid="design-page">
      <div className="text-center space-y-1">
        <h1 className="text-xl font-black">{ar ? "🌸 تصميم خاص بذوق عميلنا" : "🌸 A customer's custom design"}</h1>
        {design.label && <div className="text-xs opacity-70" data-testid="design-label">{design.label}</div>}
      </div>
      <img src={src(design.image)} alt="" className="w-full rounded-2xl border" style={{ borderColor: "var(--border)" }} data-testid="design-image" />
      {product ? (
        <div className="rounded-2xl border p-4 space-y-2.5 text-center" style={{ borderColor: "var(--border)" }}>
          <div className="text-sm font-bold" data-testid="design-product-name">{ar ? product.name_ar : product.name_en || product.name_ar}</div>
          {Number(product.price_sar) > 0 && (
            <div className="text-lg font-black">{Number(product.price_sar).toLocaleString("en")} {ar ? "ر.ق" : "QAR"}</div>
          )}
          <button onClick={() => nav(`/p/${product.id}`)} className="btn-primary w-full !py-3" data-testid="design-buy-btn">
            <ShoppingBag size={16} /> {ar ? "اطلبه الآن وصمّمه بذوقك" : "Order now & make it yours"}
          </button>
          <div className="text-[11px] opacity-60 flex items-center justify-center gap-1">
            <Wand2 size={12} /> {ar ? "بصفحة المنتج تقدر تعدّله بذوقك بالذكاء الاصطناعي" : "Customise it with AI on the product page"}
          </div>
        </div>
      ) : (
        <button onClick={() => nav("/")} className="btn-primary w-full !py-3" data-testid="design-home-btn">
          {ar ? "تسوّق الآن من RG" : "Shop RG now"}
        </button>
      )}
      <div className="text-center">
        <Link to="/designs" className="chip !text-xs inline-flex items-center gap-1" data-testid="design-gallery-link">
          <LayoutGrid size={12} /> {ar ? "شاهد معرض تصاميم العملاء" : "Browse customer designs gallery"}
        </Link>
      </div>
    </div>
  );
}
